import React from 'react';
import './App.css';
import Maingame from "./components/maingame"

function App() {
  return (
    <div className="App">
    <h1>TIC TAC TOE</h1>
    <Maingame/>
    </div>
  );
}


export default App;
